﻿import $ from "jquery";
import * as FormHelper from "../utils/formHelper"

const newsletterSubscribePanel = $(".js--subscribe-panel");
const emailconsentsbox = newsletterSubscribePanel.find(".js--subscribe-popup-consents");
const emailerrorbox = newsletterSubscribePanel.find(".email__section");
var contactFormFields;


let checkIfFormIsValid = function () {
    const expression = /^[\w\-\.\+]+\@[a-zA-Z0-9\.\-]+\.[a-zA-z0-9]{2,4}$/;
    let isInputValid = true;
    let firstNameField = $(newsletterSubscribePanel).find("input[name='js--subscribe-popup-firstname']");
    let lastNameField = $(newsletterSubscribePanel).find("input[name='js--subscribe-popup-lastname']");
    let emailField = $(newsletterSubscribePanel).find("input[name='js--subscribe-popup-email']");
    let consentField = $(newsletterSubscribePanel).find("input[name='js--subscribe-popup-consents']");

    if (!firstNameField.parent().hasClass("is-filled")) {
        firstNameField.parent().addClass("is-invalid");
        isInputValid = false;
    } else {
        firstNameField.parent().removeClass("is-invalid");
    }

    if (!lastNameField.parent().hasClass("is-filled")) {
        lastNameField.parent().addClass("is-invalid");
        isInputValid = false;
    } else {
        lastNameField.parent().removeClass("is-invalid");
    }

    if (!emailField.parent().hasClass("is-filled")) {
        emailField.parent().addClass("is-invalid");
        isInputValid = false;
    } else {
        if (expression.test(emailField)) {
            emailField.parent().removeClass("is-invalid");
            console.log("test failed");
        } else {
            emailField.parent().addClass("is-invalid");
            isInputValid = false;
        }
    }

    if (document.querySelector('input[name="js--subscribe-popup-consents"]:checked')) {
        consentField.parent().removeClass("is-invalid");
    } else {
        isInputValid = false;
        consentField.parent().addClass("is-invalid");
    }

    return isInputValid;
};

let subscribe = () => {
    var linkToRedirect = $(newsletterSubscribeSection).find(".submit-button").attr("href");
    var subscriptionListsIds =
        FormHelper.GetDataAttributesArray(newsletterSubscribeSection,
            ".subscription-list:checked",
            "subscription-list");
    //var categoriesIds = FormHelper.GetValuesArray(newsletterSubscribePanel, ".newsletter-category:checked");
    var firstname = newsletterSubscribePanel.find(".js--subscribe-popup-firstname").val();
    var lastname = newsletterSubscribePanel.find(".js--subscribe-popup-lastname").val();
    var email = newsletterSubscribePanel.find(".js--subscribe-popup-email").val();
    var emailconsents = newsletterSubscribePanel.find(".js--subscribe-popup-consents").prop("checked");


    if (emailconsents) {
        $.ajax({
            type: "post",
            url: "/api/NewsletterApi/Subscribe",
            data: {
                subscriptionListsIds: subscriptionListsIds,
                categoriesIds: categoriesIds,
                email: email
            },
            success: function () {
                window.location.href = `${linkToRedirect}`;
            },
            error: function () {
                $(emailerrorbox).addClass("is-invalid");
                $("#errorMessage").show();
            }
        });

    } else {
        $(emailconsentsbox).css("border", "1px solid #d73d3d");
    }

};

$(newsletterSubscribePanel).on("click",
    ".js--subscribe-popup-submit",
    function (e) {
        e.preventDefault();

        contactFormFields = $(".js--subscribe-panel :input");
        console.log(contactFormFields);

        if (!contactFormFields) {
            return;
        }
        if (checkIfFormIsValid()) {
            console.log("valid");
            $(this).parent().hide();
            //  subscribe();
        }

        $(emailerrorbox).removeClass("is-invalid");
        $(emailconsentsbox).css("border", "none");
        $("#errorMessage").hide();
    
    });


//////////////////
// WEBPACK FOOTER
// ./Scripts/newsletter/newsletterPopupSubscribe.js
// module id = 13
// module chunks = 1